<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.$route.name == "CollaboratorPlayers") {
      this.mainTab();
    }
  },
  watch: {
    $route(val) {
      if (val.name == "CollaboratorPlayers") {
        this.mainTab();
      }
    },
  },

  computed: {
    canSearchPlayer() {
      return this.$permission("25");
    },
    canListOnlinePlayers() {
      return this.$permission("32");
    },
    canExportInactivePlayers() {
      return this.$permission("33");
    },
    canSeeTotalOnlineBalance() {
      return this.$permission("35");
    },
    canSeeDocumentVerification() {
      return this.$permission("60");
    },
  },
  methods: {
    mainTab() {
      let name = "";

      if (this.canSearchPlayer) {
        name = "CollaboratorAccountabilityOnlinePlayersOnlineSearch";
      } else if (this.canListOnlinePlayers) {
        name = "CollaboratorListPlayersOnline";
      } else if (this.canExportInactivePlayers) {
        name = "CollaboratorPlayersOnlineInactives";
      } else if (this.canSeeTotalOnlineBalance) {
        name = "CollaboratorTotalOnlineBalance";
      } else if (this.canSeeDocumentVerification) {
        name = "CollaboratorDocumentVerification";
      }

      this.$router.push({ name });
    },
  },
};
</script>
